import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueRouter from 'vue-router'
import Swal from 'sweetalert2'

//load font awesome


Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

import Home       from './components/Home.vue'
import Tag        from './components/Tag.vue'
import Setup      from './components/Setup.vue'
import SetupReturn from './components/SetupReturn.vue'
import TapOn      from './components/TapOn.vue' 
import TapOff     from './components/TapOff.vue' 
import TapRunning from './components/TapRunning.vue' 
import Timesheet  from './components/Timesheet.vue' 
import Timesheets from './components/Timesheets.vue' 
import All        from './components/All.vue' 
import Debug        from './components/Debug.vue' 


const routes = [
  { path: '/setup', component: Setup },
  { path: '/setupreturn', component: SetupReturn },
  { path: '/tag', component: Tag },
  { path: '/home', component: Home },
  { path: '/setup', component: Setup },
  { path: '/tapon', component: TapOn },
  { path: '/tapoff', component: TapOff },
  { path: '/taprunning', component: TapRunning },
  { path: '/timesheet', component: Timesheet },
  { path: '/timesheets', component: Timesheets },
  { path: '/all', component: All },
  { path: '/debug', component: Debug },
  { path: '*', component: Home }
]
const router = new VueRouter({
  base: __dirname,
  routes,
  mode: 'history'
});

window.latestlogs = '';
try {
window.vm = new Vue({
  render: h => h(App),
  router,
  runtimeCompiler:true
}).$mount('#app')
} catch(error){
  window.latestlogs += error.toString();
  alert(error.toString());
}



